import { useCallback } from 'react';
import useUrlBuilder from '@/util/useUrlBuilder';
import { useHasEquipmentPermit } from '@/view/fleet/utils/useHasEquipmentPermit';
import { equipmentDataFullPath } from '@/view/pathDefinitions';
import type { DateRangeParams } from '../types';

export type ViewBearingRollingElement = (params?: DateRangeParams) => void;

export const useViewBearingRollingElement = (
  equipmentId: string
): ViewBearingRollingElement | undefined => {
  const { buildUrl } = useUrlBuilder();
  const { hasPermit } = useHasEquipmentPermit(equipmentId, 'eqmnt.trends:r');

  const navigate = useCallback(
    (params?: DateRangeParams) => {
      buildUrl(equipmentDataFullPath)
        .setParam('selected', equipmentId)
        .setParam('tab', 'screen_tab_trend')
        .setParam('from', params?.from?.toISOString())
        .setParam('to', params?.to?.toISOString())
        .setAnchor('screen_diagram_specific_bearing_condition_rolling_element')
        .push();
    },
    [buildUrl, equipmentId]
  );

  return hasPermit ? navigate : undefined;
};
